export const DATES_SELECT_DAY = 'DATES_SELECT_DAY';
export const DATES_HALF_DAY = 'DATES_HALF_DAY';
export const DATES_CHANGE_DAYS_PER_YEAR = 'DATES_CHANGE_DAYS_PER_YEAR';
export const DATES_SELECT_START_MONTH = 'DATES_SELECT_START_MONTH';
export const DATES_SELECT_HOLIDAY = 'DATES_SELECT_HOLIDAY';
export const DATES_SELECT_END_OF_CURRENT = 'DATES_SELECT_END_OF_CURRENT';
export const DATES_CHANGE_YEAR = 'DATES_CHANGE_YEAR';
export const DATES_DESELECT = 'DATES_DESELECT';
export const DATES_UPDATE_CARRIED_OVER = 'DATES_UPDATE_CARRIED_OVER';
export const DATES_UPDATE_PER_YEAR = 'DATES_UPDATE_PER_YEAR';
export const FETCH_DATES_FROM_SERVER = 'FETCH_DATES_FROM_SERVER';
export const LOAD_DATES_FROM_SERVER = 'LOAD_DATES_FROM_SERVER';
export const UPDATE_BANK_HOLIDAYS = 'UPDATE_BANK_HOLIDAYS';
export const DATES_RENAME_HOLIDAY = 'DATES_RENAME_HOLIDAY';
export const DATES_RENAME_BANK_HOLIDAY = 'DATES_RENAME_BANK_HOLIDAY';
export const DATES_CONVERT_TO_BANK_HOLIDAY = 'DATES_CONVERT_TO_BANK_HOLIDAY';
export const DATES_REMOVE_BANK_HOLIDAY = 'DATES_REMOVE_BANK_HOLIDAY';
export const DATES_UPSERT_MEMORABLE_CALENDAR = 'DATES_UPSERT_MEMORABLE_CALENDAR';
export const DATES_REMOVE_MEMORABLE_CALENDAR = 'DATES_REMOVE_MEMORABLE_CALENDAR';
export const DATES_UPSERT_MEMORABLE_DATE = 'DATES_UPSERT_MEMORABLE_DATE';
export const DATES_REMOVE_MEMORABLE_DATE = 'DATES_REMOVE_MEMORABLE_DATE';
